document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver(initCustomAddToCart);
  observer.observe(document.body, { childList: true, subtree: true });
  initCustomAddToCart();

  function initCustomAddToCart() {
    const productForms = document.querySelectorAll('product-form form[action^="/cart/add"]');
    productForms.forEach(form => {
      if (form.dataset.customHandlerAttached) return;
      form.dataset.customHandlerAttached = true;

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        const formData = new FormData(form);

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!response.ok) throw new Error('Add to cart failed');

          const item = await response.json();
          const quantityAdded = parseInt(formData.get('quantity')) || 1;

          // Always show single-item modal for single-product forms
          showCartModal({ multiple: false, item, quantityAdded });

          updateCartCount();
        } catch (err) {
          console.error('Error adding to cart:', err);
        }
      }, true);
    });
  }

  if (window.jQuery) {
    jQuery(document).off('click.customAdd').on('click.customAdd', '.add-to-cart', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation(); // prevent any other handlers

      const $ = jQuery;
      const itemsToAdd = [];

      $('#section--customer-output tr[data-sku]').each(function () {
        const sku = String($(this).data('sku') || '');
        if (!sku) return;

        const qText = $(this).find('.sys-qty, .sys-qty-2, .swaging-qty, .wire-qty').first().text().trim();
        const qty = parseInt(qText.replace(/[^0-9]/g, ''), 10) || 0;
        if (qty <= 0) return;

        const el = $('[data-sku="' + sku + '"][data-variant-id]').first();
        const variantId = el.length ? Number(el.data('variant-id')) : null;

        if (!variantId) {
          console.warn('Add to cart: missing variant for SKU:', sku);
          alert('Product not found for SKU: ' + sku + '. Please contact support.');
          itemsToAdd.length = 0;
          return false; // break out
        }

        itemsToAdd.push({ id: variantId, quantity: qty });
      });

      if (itemsToAdd.length === 0) return;

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        contentType: 'application/json',
        data: JSON.stringify({ items: itemsToAdd }),
        dataType: 'json'
      })
        .done(function (response) {
          // Show modal: only "multiple" if more than 1 different item is added
          showCartModal({ multiple: itemsToAdd.length > 1 });
          updateCartCount();
        })
        .fail(function (xhr) {
          console.error('Add to cart failed', xhr.responseText || xhr);
          alert('Unable to add items to cart. Check console for details.');
        });
    });

    $(document).off('click.customAddUpsell').on('click.customAddUpsell', '.addtocart', async function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const button = $(this);
      const variantId = button.data('variant-id');
      const form = button.closest('form');
      const qtyInput = form.find('input[name="quantity"]');
      const quantity = parseInt(qtyInput.val()) || 1;

      if (!variantId) {
        console.warn('Missing variant ID on upsell Add to Cart button');
        return;
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity })
        });

        if (!response.ok) throw new Error('Add to cart failed');
        const item = await response.json();

        showCartModal({ multiple: false, item, quantityAdded: quantity });
        updateCartCount();
      } catch (err) {
        console.error('Error adding to cart:', err);
        alert('Unable to add this item to cart. Check console for details.');
      }
    });
  }

  function showCartModal({ multiple, item, quantityAdded }) {
    const modal = document.getElementById('cart-modal');
    const modalContent = modal.querySelector('.cart-modal-content');

    if (multiple) {
      modalContent.innerHTML = `
        ${cartModalHeading()}
        <p class="multiple-items-heading">All selected items added to cart.</p>
        ${modalButtons()}
      `;
    } else {
      modalContent.innerHTML = `
        ${cartModalHeading()}
        <div class="cart-item-pop-up">
          <img src="${item.image}" alt="${item.title}">
            <p><strong>${quantityAdded}</strong> x ${item.title}</p>
        </div>
        ${modalButtons()}
      `;
    }

    modal.classList.add('active');
  }

  function cartModalHeading() {
    return `
      <span id="cart-remove-close" class="remove-popup-btn"></span>
      <div class="cart-heading">
        <p>Items has been added to your cart</p>
      </div>
    `;
  }


  function modalButtons() {
    return `
      <div class="cart-popup-buttons">
        <div class="popup-buttons-right">
          <button class="cart-popup-btn popup-continue">Continue Shopping</button>
          <button class="cart-popup-btn popup-view">View My Cart</button>
        </div>
        <div class="popup-buttons-left">
          <button class="cart-popup-btn popup-checkout">Checkout Now</button>
        </div>
      </div>
    `;
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const bubble = document.querySelector('[data-cart-count-bubble]');
        if (bubble) bubble.textContent = cart.item_count;
      });
  }

  document.addEventListener('click', (e) => {
    const modal = document.getElementById('cart-modal');

    // Close modal when clicking background, close button, or "Continue Shopping"
    if (
      e.target.matches('.cart-modal') ||
      e.target.matches('.cart-modal-close') ||
      e.target.matches('.cart-btn.cart-continue') ||
      e.target.matches('#cart-remove-close') // <- new close button
    ) {
      modal.classList.remove('active');
    }

    if (e.target.matches('.cart-btn.cart-view')) {
      window.location.href = '/cart';
    }

    if (e.target.matches('.cart-btn.cart-checkout')) {
      window.location.href = '/checkout';
    }
  });
});
